exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info_title[data-v-5540e6ee]{margin-bottom:20px;-ms-flex-wrap:wrap;flex-wrap:wrap}.info_title[data-v-5540e6ee],.info_title .line_box[data-v-5540e6ee]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.info_title .line_box[data-v-5540e6ee]{margin:0 35px 10px 0}.commodity_title[data-v-5540e6ee],.info_title .line_box .title[data-v-5540e6ee]{font-weight:700;color:#333}.commodity_title[data-v-5540e6ee]{font-size:14px;margin:30px 0 8px 0}", ""]);

// exports
